export type TimezoneOption = {
  timezone?: string
}

/** Clock format for time-of-day displays. `null` on a setting = locale default. */
export const TOD_DISPLAY_FORMATS = ['12hNoAmPm', '12h', '24h'] as const

export type TodDisplayFormat = (typeof TOD_DISPLAY_FORMATS)[number]

export type HmsTouple = {
  hours: number
  minutes: number
  seconds: number
  decimals?: number
}

export type Dhms = {
  days: number
  hours: number
  minutes: number
  seconds: number
}
